export const perfectNumbers = [6, 28, 496, 8128, 33550336, 8589869056, 137438691328]
